import { DbSortOrder } from "src/models/common/TPESearchRequest";
import DASHBOARD_CONSTANTS from "../dashboardConstants";
import { TasksSearchRequest } from "src/models/dashboard/Task";

export function getTopOpenTaksSearchPayload(): TasksSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.SMALL_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_REQUEST_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
        status: DASHBOARD_CONSTANTS.ACTIVE_STATUS
    };
}

export function getAllTasksSearchPayload(): TasksSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.ALL_TASKS_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_TASK_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
        status: DASHBOARD_CONSTANTS.ACTIVE_STATUS
    };
}